<template>
  <div class="player-stat">
    <img loading="lazy" sizes="100%, 100%" width="auto" height="30px" :src="iconImage"
         :title="icon">
    <span class="stat-value mt-1" :class="contextClass">{{boost > 0 ? '+':''}}{{value + boost}}</span>
  </div>
</template>

<script>
  export default {
    name: "EquipmentStat",
    props: {
      icon: {
        type: String,
        default: 'hitpoints'
      },
      value: {
        type: Number,
        default: 0,
      },
      boost: {
        type: Number,
        default() {
          return 0
        }
      }
    },
    computed: {
      iconImage: function () {
        return `/static/images/icons/${this.icon}.png`
      },
      contextClass: function () {
        return {
          'boosted': this.boost > 0,
        }
      },
    },
    methods: {
      addOperator: function (val) {
        if (val > 0) {
          return '+' + val
        }

        return val;
      },
    }
  }
</script>

<style scoped>
  .stat-value {
    display: block;
    font-size: 1.3rem;
    color: white;
    text-shadow: 0.1rem 0.1rem black;
    font-family: 'RuneScape UF', sans-serif;
    letter-spacing: 0.1rem;
  }

  /*.stat-value.boosted {*/
  /*  color: green;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/stats/EquipmentStat.vue